const logout = async () => {
  localStorage.removeItem('isAuthenticated');
  localStorage.removeItem('user_credentials');
  localStorage.removeItem('user_token');
  location.reload();
};

export { logout };
